

// // // // export default Login;
// // // import { useState, useContext } from 'react';
// // // import { useNavigate } from 'react-router-dom';
// // // import { AuthContext } from '../../context/authContext';
// // // import './Login.css'; // Ensure this is the correct path to your CSS file

// // // const Login = () => {
// // //   const { login } = useContext(AuthContext);
// // //   const [portal_id, setPortal_id] = useState('');
// // //   const [password, setPassword] = useState('');
// // //   const [error, setError] = useState(null);
// // //   const navigate = useNavigate();

// // //   const handleLogin = async (e) => {
// // //     e.preventDefault();
// // //     setError(null);

// // //     try {
// // //       await login(portal_id, password);
// // //       navigate('/');
// // //     } catch (err) {
// // //       setError(err.message);
// // //     }
// // //   };

// // //   return (
// // //     <div className="login-container">
// // //        <img
// // //            src="https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/VGVhcEFsdmZKYnQwYTJoSVJvUFJPZz09/lsdc.png"
// // //               alt="Program Banner"
// // //             />
// // //       <div className="login-box">
// // //         <h1 className="login-title">Login</h1>
// // //         <form onSubmit={handleLogin} className="login-form">
// // //           <input
// // //             type="text"
// // //             placeholder="Portal ID"
// // //             value={portal_id}
// // //             onChange={(e) => setPortal_id(e.target.value)}
// // //             required
// // //             className="login-input"
// // //           />
// // //           <input
// // //             type="password"
// // //             placeholder="Password"
// // //             value={password}
// // //             onChange={(e) => setPassword(e.target.value)}
// // //             required
// // //             className="login-input"
// // //           />
// // //           <button type="submit" className="login-button">Login</button>
// // //           {error && <p className="login-error">{error}</p>}
// // //         </form>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default Login;


// // import { useState, useContext } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import { AuthContext } from '../../context/authContext';
// // import './Login.css';

// // const Login = () => {
// //   const { login } = useContext(AuthContext);
// //   const [portal_id, setPortal_id] = useState('');
// //   const [password, setPassword] = useState('');
// //   const [error, setError] = useState(null);
// //   const [isLoading, setIsLoading] = useState(false);
// //   const navigate = useNavigate();

// //   const handleLogin = async (e) => {
// //     e.preventDefault();
// //     setError(null);
// //     setIsLoading(true);

// //     try {
// //       await login(portal_id, password);
// //       navigate('/');
// //     } catch (err) {
// //       setError(err.message);
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   return (
// //     <div className="login-container">
// //       {/* Animated background particles */}
// //       <div className="bg-particles">
// //         <div className="particle"></div>
// //         <div className="particle"></div>
// //         <div className="particle"></div>
// //         <div className="particle"></div>
// //         <div className="particle"></div>
// //         <div className="particle"></div>
// //         <div className="particle"></div>
// //         <div className="particle"></div>
// //         <div className="particle"></div>
// //         <div className="particle"></div>
// //       </div>

// //       <div className="login-wrapper">
// //         <div className="login-brand">
// //           <img
// //             src="https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/VGVhcEFsdmZKYnQwYTJoSVJvUFJPZz09/lsdc.png"
// //             alt="Program Banner"
// //             className="login-logo"
// //           />
// //           {/* <div className="brand-text">
// //             <h2>Welcome Back</h2>
// //             <p>Sign in to continue your journey</p>
// //           </div> */}
// //         </div>

// //         <div className="login-box">
// //           <div className="login-header">
// //             <h1 className="login-title">Welcome Back</h1>
// //             <p className="login-subtitle">Enter your credentials to access your account</p>
// //           </div>

// //           <form onSubmit={handleLogin} className="login-form">
// //             <div className="input-group">
// //               <label htmlFor="portal_id">Portal ID</label>
// //               <div className="input-icon-wrapper">
// //                 <i className="fas fa-user input-icon"></i>
// //                 <input
// //                   id="portal_id"
// //                   type="text"
// //                   placeholder="Enter your Portal ID"
// //                   value={portal_id}
// //                   onChange={(e) => setPortal_id(e.target.value)}
// //                   required
// //                   className="login-input"
// //                   autoComplete="username"
// //                 />
// //               </div>
// //             </div>

// //             <div className="input-group">
// //               <label htmlFor="password">Password</label>
// //               <div className="input-icon-wrapper">
// //                 <i className="fas fa-lock input-icon"></i>
// //                 <input
// //                   id="password"
// //                   type="password"
// //                   placeholder="Enter your password"
// //                   value={password}
// //                   onChange={(e) => setPassword(e.target.value)}
// //                   required
// //                   className="login-input"
// //                   autoComplete="current-password"
// //                 />
// //               </div>
// //             </div>

// //             <button 
// //               type="submit" 
// //               className={`login-button ${isLoading ? 'loading' : ''}`}
// //               disabled={isLoading}
// //             >
// //               {isLoading ? (
// //                 <span className="spinner"></span>
// //               ) : (
// //                 <>
// //                   <i className="fas fa-sign-in-alt"></i>
// //                   Sign In
// //                 </>
// //               )}
// //             </button>

// //             {error && (
// //               <div className="login-error">
// //                 <i className="fas fa-exclamation-circle"></i>
// //                 {error}
// //               </div>
// //             )}
// //           </form>

// //           <div className="login-footer">
// //             {/* <p>
// //               Don't have an account? <a href="#" className="signup-link">Sign up here</a>
// //             </p> */}
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Login;



// import { useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { AuthContext } from '../../context/authContext';
// import './Login.css';
// import PersonIcon from '@mui/icons-material/Person';
// import LockIcon from '@mui/icons-material/Lock';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// import LoginIcon from '@mui/icons-material/Login';

// const Login = () => {
//   const { login } = useContext(AuthContext);
//   const [portal_id, setPortal_id] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setIsLoading(true);

//     try {
//       await login(portal_id, password);
//       navigate('/');
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   return (
//     <div className="login-container">
//       {/* Animated background particles */}
//       <div className="bg-particles">
//         <div className="particle"></div>
//         <div className="particle"></div>
//         <div className="particle"></div>
//         <div className="particle"></div>
//         <div className="particle"></div>
//         <div className="particle"></div>
//         <div className="particle"></div>
//         <div className="particle"></div>
//         <div className="particle"></div>
//         <div className="particle"></div>
//       </div>

//       <div className="login-wrapper">
//         <div className="login-brand">
//           <img
//             src="https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/VGVhcEFsdmZKYnQwYTJoSVJvUFJPZz09/lsdc.png"
//             alt="Program Banner"
//             className="login-logo"
//           />
//         </div>

//         <div className="login-box">
//           <div className="login-header">
//             <h1 className="login-title">Welcome Back</h1>
//             <p className="login-subtitle">Enter your credentials to access your account</p>
//           </div>

//           <form onSubmit={handleLogin} className="login-form">
//             <div className="input-group">
//               <label htmlFor="portal_id">Portal ID</label>
//               <div className="input-icon-wrapper">
//                 <PersonIcon className="input-icon" />
//                 <input
//                   id="portal_id"
//                   type="text"
//                   placeholder="Enter your Portal ID"
//                   value={portal_id}
//                   onChange={(e) => setPortal_id(e.target.value)}
//                   required
//                   className="login-input"
//                   autoComplete="username"
//                 />
//               </div>
//             </div>

//             <div className="input-group">
//               <label htmlFor="password">Password</label>
//               <div className="input-icon-wrapper password-wrapper">
//                 <LockIcon className="input-icon" />
//                 <input
//                   id="password"
//                   type={showPassword ? "text" : "password"}
//                   placeholder="Enter your password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   required
//                   className="login-input password-input"
//                   autoComplete="current-password"
//                 />
//                 <button 
//                   type="button"
//                   className="password-toggle-btn"
//                   onClick={togglePasswordVisibility}
//                   aria-label={showPassword ? "Hide password" : "Show password"}
//                 >
//                   {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
//                 </button>
//               </div>
//             </div>

//             <button 
//               type="submit" 
//               className={`login-button ${isLoading ? 'loading' : ''}`}
//               disabled={isLoading}
//             >
//               {isLoading ? (
//                 <span className="spinner"></span>
//               ) : (
//                 <>
//                   <LoginIcon />
//                   Sign In
//                 </>
//               )}
//             </button>

//             {error && (
//               <div className="login-error">
//                 <span className="error-icon">⚠️</span>
//                 {error}
//               </div>
//             )}
//           </form>

//           <div className="login-footer">
//             {/* Footer content if needed */}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;


import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/authContext';
import './Login.css';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LoginIcon from '@mui/icons-material/Login';

const Login = () => {
  const { login, adminLogin } = useContext(AuthContext);
  const [portal_id, setPortal_id] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      // Try admin login first
      const isAdmin = adminLogin(portal_id, password);
      
      if (isAdmin) {
        // Admin login successful - navigate to home
        navigate('/');
        // Reload to refresh context
        window.location.reload();
      } else {
        // Regular user login
        await login(portal_id, password);
        navigate('/');
      }
    } catch (err) {
      setError(err.message || 'Invalid credentials. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-container">
      <div className="bg-particles">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>

      <div className="login-wrapper">
        <div className="login-brand">
          <img
            src="https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/VGVhcEFsdmZKYnQwYTJoSVJvUFJPZz09/lsdc.png"
            alt="Program Banner"
            className="login-logo"
          />
        </div>

        <div className="login-box">
          <div className="login-header">
            <h1 className="login-title">Welcome Back</h1>
            <p className="login-subtitle">Enter your credentials to access your account</p>
          </div>

          <form onSubmit={handleLogin} className="login-form">
            <div className="input-group">
              <label htmlFor="portal_id">Portal ID</label>
              <div className="input-icon-wrapper">
                <PersonIcon className="input-icon" />
                <input
                  id="portal_id"
                  type="text"
                  placeholder="Enter your Portal ID"
                  value={portal_id}
                  onChange={(e) => setPortal_id(e.target.value)}
                  required
                  className="login-input"
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="input-group">
              <label htmlFor="password">Password</label>
              <div className="input-icon-wrapper password-wrapper">
                <LockIcon className="input-icon" />
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="login-input password-input"
                  autoComplete="current-password"
                />
                <button 
                  type="button"
                  className="password-toggle-btn"
                  onClick={togglePasswordVisibility}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </button>
              </div>
            </div>

            <button 
              type="submit" 
              className={`login-button ${isLoading ? 'loading' : ''}`}
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="spinner"></span>
              ) : (
                <>
                  <LoginIcon />
                  Sign In
                </>
              )}
            </button>

            {error && (
              <div className="login-error">
                <span className="error-icon">⚠️</span>
                {error}
              </div>
            )}
          </form>

          <div className="login-footer">
            {/* Footer content if needed */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;